// extracted by mini-css-extract-plugin
export var numpadContainer = "_ma-1";
export var phoneButton = "_ma-0";